import * as React from 'react';
import { reportError } from 'Common/Errors/ErrorReporter';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import ErrorIcon from '@material-ui/icons/Error';
import { Typography } from '@material-ui/core';

interface IProps {
    children: any
}

interface IState {
    hasError: boolean;
    reportingError: boolean;
    description: string;
}

class ErrorBoundary extends React.Component<IProps, IState> {

    state: IState;

    props!: IProps;

    constructor(props: IProps) {
        super(props);
        this.state = {
            hasError: false,
            reportingError: false,
            description: 'Test description'
        };
    }

    static getDerivedStateFromError = (error: any) => {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch = (error: any, errorInfo: any) => {
        // You can also log the error to an error reporting service
        let formattedError = typeof error == "string" ? error : JSON.stringify(error);
        let formattedErrorInfo = typeof errorInfo == "string" ? errorInfo : JSON.stringify(errorInfo);
        this.setState({ reportingError: true, description: 'Please wait while we report this error to our team...' })
        reportError(formattedError, formattedErrorInfo)
            .then(() => {
                this.setState({
                    reportingError: false,
                    description: 'The error was successfully reported to our team.  You can now refresh the page to continue.'
                })
            }).catch(error => {
                this.setState({
                    reportingError: false,
                    description: 'We were unable to report this error. You can now refresh the page to continue.'
                })
            })
    }

    render = () => {

        const { hasError, reportingError, description } = this.state;

        if (hasError) {
            // You can render any custom fallback UI
            return <Dialog
                disableBackdropClick
                disableEscapeKeyDown
                maxWidth="xs"
                aria-labelledby="confirmation-dialog-title"
                open={true}
            >
                <DialogContent
                    style={{
                        display: 'flex',
                        flexDirection: 'column' as 'column',
                        alignItems: 'center'
                    }}
                    dividers
                >
                    <ErrorIcon
                        style={{
                            width: '2em',
                            height: '2em',
                            margin: '1em',
                            color: "#D51535"
                        }}
                    />
                    <Typography variant="h6" align="center">
                        It appears we encountered and unexpected error.
                    </Typography>
                    <br/>
                    <Typography variant="body1" align="center">
                        {description}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => window.location.reload(true)}
                        color="primary"
                        disabled={reportingError}
                    >
                        Refresh
                </Button>
                </DialogActions>
            </Dialog>
        }

        return this.props.children;
    }
}

export default ErrorBoundary;